import { render, staticRenderFns } from "./modal-aviso-privacy.vue?vue&type=template&id=5941d870&lang=html&"
import script from "./modal-aviso-privacy.vue?vue&type=script&lang=js&"
export * from "./modal-aviso-privacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports